import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IFilter {
    questions: string[];
    answers: string[];
    operator?: string;
    date?: string;
}

interface IDataAnalyticsFilter {
    filter: IFilter;
}

const initialState: IDataAnalyticsFilter = {
    filter: {
        questions: [],
        answers: [],
        operator: '',
        date: '',
    },
};

const dataAnalyticsFilterSlice = createSlice({
    name: 'dataAnalyticsFilter',
    initialState,
    reducers: {
        setFilter: (state, action: PayloadAction<IFilter>) => {
            state.filter = action.payload;
        },
    },
});

export const { setFilter } = dataAnalyticsFilterSlice.actions;

export default dataAnalyticsFilterSlice.reducer;
